import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, CheckCircle, XCircle, Clock, Timer } from 'lucide-react';
import { convertTo12HourIfNeeded } from '../../../services/TimeFormat24hr';

const statusMap = {
    completed: { icon: CheckCircle, color: 'text-green-500' },
    active: { icon: CheckCircle, color: 'text-green-500' },
    expired: { icon: Clock, color: 'text-yellow-500' },
    missed: { icon: Clock, color: 'text-yellow-500' },
    cancelled: { icon: XCircle, color: 'text-red-500' },
    inactive: { icon: XCircle, color: 'text-red-500' },
};

const SessionHistoryCard = ({ userDetails, sessionHistory }) => {
    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: { y: 0, opacity: 1 }
    };
    const plan = userDetails?.plan ?? {};
    const StatusIcon = statusMap?.active?.icon || Clock;
    const statusColor = statusMap?.active?.color || 'text-gray-500';
    return (
        <motion.div
            variants={itemVariants}
            className="bg-white p-6 rounded-xl shadow-sm border border-gray-200"
        >
            <h3 className="text-xl font-bold text-gray-800 font-display mb-4">
                Session History
            </h3>

            {sessionHistory?.length > 0 ? (
                <div className="space-y-4">
                    {sessionHistory.map((session) => {
                        const statusColor = statusMap[session?.status]?.color
                        const startTime = convertTo12HourIfNeeded(session?.start_time ?? '0:00');
                        const endTime = convertTo12HourIfNeeded(session.end_time ?? '0:00');
                        
                        return (
                            <div
                                key={session.id}
                                className="p-4 bg-gray-50 rounded-lg border border-gray-200"
                            >
                                <div className="flex items-start gap-4">
                                    {/* Status Icon */}
                                    <div className={`p-2 bg-white rounded-full border ${statusColor}`}>
                                        <StatusIcon size={20} />
                                    </div>

                                    <div className="flex-1">
                                        {/* Title + Status */}
                                        <div className="flex justify-between items-center mb-1">
                                            <p className="font-semibold text-gray-800">
                                                {session.date}  
                                            </p>
                                            <span className={`text-sm font-semibold ${statusColor}`}>
                                                {session.status.charAt(0).toUpperCase() +
                                                    session.status.slice(1)}
                                            </span>
                                        </div>

                                        {/* Session Date & Time */}
                                        <div className="text-sm text-gray-600 flex items-center gap-2">
                                            <Clock size={14} />
                                            <span>
                                                 {startTime} to {endTime}
                                            </span>
                                        </div>

                                        {/* Booked By */}
                                        <p className="text-sm text-gray-500 mt-1">
                                            Booked By: <span className="font-medium text-gray-700">{session.booked_by}</span>
                                        </p>

                                        {/* Created/Updated Times */}
                                        {/* <p className="text-xs text-gray-400 mt-1">
                                            Created: {new Date(session.created_at).toLocaleString()}
                                        </p>
                                        <p className="text-xs text-gray-400">
                                            Updated: {new Date(session.updated_at).toLocaleString()}
                                        </p> */}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p className="text-gray-500 text-sm">No session history available.</p>
            )}

        </motion.div>
    );
};

export default SessionHistoryCard;
